// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue"
// import VeHistogram from "v-charts/lib/echarts"
import VLine from "v-charts/lib/line.common.js"
import ElementUI from 'element-ui'
import App from "./App.vue"
import store from './store'
import i18n from './language'
import "element-ui/lib/theme-chalk/index.css"
import LangStorage from './language/lang'
import router from "./router"
import './assets/font/molyb.js'
import ECharts from 'vue-echarts'
// console.log(echarts, 'echartsechartsecharts')


//import * as VueGoogleMaps from 'vue2-google-maps'
// import registerElementComponents from "@/helper/registerElementComponents"
import registerCustomComponents from "@/helper/registerCustomComponents"
import "@/helper/googlePlacesAutocomplete.css"

// Vue.component('VeHistogram', VeHistogram)
window.websock = null
Vue.component(VLine.name, VLine)
console.log(ECharts, 'EChartsECharts')
Vue.component('v-chart', ECharts);
// Vue.prototype.$echarts = echarts
window.LangStorage = LangStorage
window.Base64 = require('js-Base64').Base64

registerCustomComponents(Vue)
// registerElementComponents(Vue)
Vue.use(ElementUI, {
  i18n: (key, value) => i18n.t(key, value)
})
Vue.config.productionTip = false

window.windowVue = new Vue({
  router,
  i18n,
  store,
  render: (h) => h(App),
}).$mount("#app")
console.log(windowVue, 'windowVue')
export default windowVue



// WEBPACK FOOTER //
// ./src/main.js